import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HorizontalFilterStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M13.75 6.25H15.25V3.75H13.75V6.25ZM16.75 6.5C16.75 7.19039 16.1903 7.75 15.5 7.75H13.5C12.8097 7.75 12.25 7.19039 12.25 6.5V3.5C12.25 2.80961 12.8097 2.25 13.5 2.25H15.5C16.1903 2.25 16.75 2.80961 16.75 3.5V6.5Z"
				fill="currentColor"
			/>
			<path
				d="M8.75 13.25H10.25V10.75H8.75V13.25ZM11.75 13.5C11.75 14.1903 11.1903 14.75 10.5 14.75H8.5C7.80961 14.75 7.25 14.1903 7.25 13.5V10.5C7.25 9.80973 7.80961 9.25 8.5 9.25H10.5C11.1903 9.25 11.75 9.80969 11.75 10.5V13.5Z"
				fill="currentColor"
			/>
			<path
				d="M11.75 20.25H13.25V17.75H11.75V20.25ZM14.75 20.5C14.75 21.1903 14.1903 21.75 13.5 21.75H11.5C10.8097 21.75 10.25 21.1903 10.25 20.5V17.5C10.25 16.8097 10.8097 16.25 11.5 16.25H13.5C14.1903 16.25 14.75 16.8097 14.75 17.5V20.5Z"
				fill="currentColor"
			/>
			<path
				d="M13 4.25C13.4142 4.25 13.75 4.58579 13.75 5C13.75 5.41421 13.4142 5.75 13 5.75H3.5C3.08579 5.75 2.75 5.41421 2.75 5C2.75 4.58579 3.08579 4.25 3.5 4.25H13Z"
				fill="currentColor"
			/>
			<path
				d="M11 18.25C11.4142 18.25 11.75 18.5858 11.75 19C11.75 19.4142 11.4142 19.75 11 19.75H3.5C3.08579 19.75 2.75 19.4142 2.75 19C2.75 18.5858 3.08579 18.25 3.5 18.25H11Z"
				fill="currentColor"
			/>
			<path
				d="M20.5 18.25C20.9142 18.25 21.25 18.5858 21.25 19C21.25 19.4142 20.9142 19.75 20.5 19.75H16.5C16.0858 19.75 15.75 19.4142 15.75 19C15.75 18.5858 16.0858 18.25 16.5 18.25H20.5Z"
				fill="currentColor"
			/>
			<path
				d="M20.5 11.25C20.9142 11.25 21.25 11.5858 21.25 12C21.25 12.4142 20.9142 12.75 20.5 12.75H11C10.5858 12.75 10.25 12.4142 10.25 12C10.25 11.5858 10.5858 11.25 11 11.25H20.5Z"
				fill="currentColor"
			/>
			<path
				d="M20.5 4.25C20.9142 4.25 21.25 4.58579 21.25 5C21.25 5.41421 20.9142 5.75 20.5 5.75H18.5C18.0858 5.75 17.75 5.41421 17.75 5C17.75 4.58579 18.0858 4.25 18.5 4.25H20.5Z"
				fill="currentColor"
			/>
			<path
				d="M5.5 11.25C5.91421 11.25 6.25 11.5858 6.25 12C6.25 12.4142 5.91421 12.75 5.5 12.75H3.5C3.08579 12.75 2.75 12.4142 2.75 12C2.75 11.5858 3.08579 11.25 3.5 11.25H5.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HorizontalFilterStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HorizontalFilterStrokeIcon;
